import React, { useState } from 'react'
import { InfoHeading, InfoDetail, InfoWrapperBox } from '../userInfoStyled';
import { useDispatch } from 'react-redux';
import { palletSupplierToggleApiCall } from "redux/actions/admin"
import AlertModal from 'web/components/AlertModal';

const InfoWrapper = ({ infoheading, infodetail, infoType = undefined, ...props }) => {
  const token = localStorage.getItem('token')
  const dispatch = useDispatch()
  const [palletSupplierState, setPalletSupplierState] = useState(infodetail)
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  let infodetailText = infodetail
  if (infoheading === 'Company Name' && infodetailText?.length > 20) {
    infodetailText = infodetailText.substring(0, 20).concat('...')
  }
  if (infoheading === "Business URL" && infodetailText?.length > 20) {
    infodetailText = infodetailText.substring(0, 20).concat('...')
  }
  const checkStyle = {
    appearance: 'auto',
    height: '17px',
    width: '17px',
    position: 'relative',
  }
  const handleCheck = async (event) => {
    let isChecked = event.target?.checked
    let data = {
      authId: props.authId,
      isPalletSupplier: isChecked
    }
    let response = await dispatch(palletSupplierToggleApiCall(token, data))
    if (response.status === 200) {
      setPalletSupplierState(isChecked)
      setModalContent(response.data?.msg)
      setModal(true)
    } else {
      setModalContent(response.data?.msg || response.message || response.data?.message || 'Something went wrong, please try again')
      setModal(true)
    }
  }
  return (
    <>
      <InfoWrapperBox className={`info-wrapper-box ${props.className || ''}`} >
        <InfoHeading>{infoheading}</InfoHeading>
        {(infoheading === "Business URL" && infodetailText?.length > 0 && infodetailText !== 'NA') ?
          <InfoDetail><a title={infodetail} target="_blank" href={(infodetail.startsWith('http://') || infodetail.startsWith('https://')) ? infodetail : 'https://' + infodetail}>{infodetailText}</a></InfoDetail>
          :
          (infoType === 'showPalletSupplier') ?
            <InfoDetail>
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}><input style={checkStyle} type="checkbox" checked={palletSupplierState} onChange={(event) => handleCheck(event)} /><p>Pallet Supplier</p></label>
            </InfoDetail>
            :
            <InfoDetail><p style={{ overflow: 'hidden', textOverflow: 'ellipsis' }} title={infodetail}>{infodetailText}</p></InfoDetail>
        }
      </InfoWrapperBox>
      {infoType === 'showPalletSupplier' &&
        <AlertModal
          isOpen={modal}
          toggle={() => setModal(!modal)}
          title=''
          content={modalContent}
        />
      }
    </>
  )
};

export default InfoWrapper;